import { FetchContext } from '../fetch-context';
import { SentEmail } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getSentEmails: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<SentEmail[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/sent-emails`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<SentEmail[]>(fetchContext.errorStore, response, 'get sent emails'));
